import _classCallCheck from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Query =
/*#__PURE__*/
function () {
  function Query() {
    _classCallCheck(this, Query);

    this.queryString = "";
    this.target = {
      source: null,
      type: null
    };
    this.geometry = null;
    this.limit = null;
    this.type = null;
  }

  _createClass(Query, [{
    key: "clone",
    value: function clone() {
      var query = new Query();
      query.queryString = this.queryString;
      query.target = {
        source: this.target.source,
        type: this.target.type
      };
      query.geometry = this.geometry;
      query.limit = this.limit;
      query.type = this.type; // list: return results until limit
      // cut: return results until limit - show new-query for the rest
      // no-cut return results if they fit in limit
      // collapse only return new-queries

      return query;
    }
  }, {
    key: "equals",
    value: function equals(testQuery) {
      if (this.queryString == testQuery.queryString && this.target.source == testQuery.target.source && this.target.type == testQuery.target.type && this.limit == testQuery.limit) //TODO: Test whether geometries are equal
        return true;else return false;
    }
  }, {
    key: "hasTarget",
    get: function get() {
      return this.target.source !== null && this.target.type !== null;
    }
  }, {
    key: "isBlank",
    get: function get() {
      return this.queryString === null || this.queryString === "";
    }
  }]);

  return Query;
}();

export { Query as default };